export const EMPTY_STRING = '';

export const CASE_INSENSITIVE_REGEX = 'i';

export const NEW_LINE = '\n';

export const SPACE = ' ';